import { ThemeProvider } from '@emotion/react';
import { theme } from '@lbcamden/lib-react';
import { Provider as TooltipProvider } from '@radix-ui/react-tooltip';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TRPCUntypedClient } from '@trpc/client';
import { AnyTRPCRouter } from '@trpc/server';
import { FunctionComponent, ReactNode } from 'react';

import { queryClient } from './lib/queryClient';
import { trpcClient, TRPCProvider } from './lib/trpc';

/** Optional props are for testing purposes */
interface Props {
  trpcClient?: TRPCUntypedClient<AnyTRPCRouter>;
  queryClient?: QueryClient;
  children: ReactNode;
}

export const AppProviders: FunctionComponent<Props> = ({
  children,
  trpcClient: trpcClientProp = trpcClient,
  queryClient: queryClientProp = queryClient,
}) => (
  <TRPCProvider client={trpcClientProp} queryClient={queryClientProp}>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <TooltipProvider>{children}</TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </TRPCProvider>
);
